import { render, staticRenderFns } from "./TabIntro.vue?vue&type=template&id=35a0814d&scoped=true"
import script from "./TabIntro.vue?vue&type=script&lang=js"
export * from "./TabIntro.vue?vue&type=script&lang=js"
import style0 from "./TabIntro.vue?vue&type=style&index=0&id=35a0814d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a0814d",
  null
  
)

export default component.exports